import { Entity, FieldType, PersistenceType, ReferenceField } from 'gossamer-unified';
import { Institution } from './Institution';

export interface OrgUnitRow {
  id: number;
  node_id: string;
  name: string;
  status: string;
  description: string | null;
  source_type: string | null;
  source_id: number | null;
  parent_org_unit_id: number | null;
  level: number;
  full_id: string;
  color_code: string | null;
  institution_id: number | null;
  created_at: string;
  updated_at: string;
}

export const OrgUnit: Entity<OrgUnitRow> = {
  id: 'OrgUnit',
  title: 'Org Unit',
  service: 'main',
  rowLabel: (row: OrgUnitRow) => row.name,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.org_unit',
  },
  security: [
    { role: 'all', action: 'read', access: 'conditional', condition: "status = 'ACTIVE'" },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition:
        "status = 'ACTIVE' AND full_id LIKE concat((select full_id from public.org_unit where source_type = 'institution' and source_id = {adminInstitutionId}), '%')",
    },
    { role: 'staff', action: 'all', access: 'conditional', condition: "status = 'ACTIVE'" },
  ],
  defaultSort: [['name', 'ASC']],
  defaultFilters: [{ fieldId: 'name', operator: 'ct', value: '' }],
  refOrderClause: 'SELECT ZZ.name FROM public.org_unit ZZ WHERE ZZ.id',
  listRowLink: '/admin/org-unit/display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    node_id: {
      seq: 10,
      type: FieldType.Text,
      label: 'Node Id',
      mandatory: true,
      maxLength: 20,
      regex: '^[a-z0-9_]{1,20}$',
      listColumn: true,
    },
    name: {
      seq: 15,
      type: FieldType.Text,
      label: 'Name',
      mandatory: true,
      listColumn: true,
      maxLength: 120,
    },
    status: {
      seq: 12,
      label: 'Status',
      type: FieldType.Options,
      mandatory: true,
      persistence: PersistenceType.BackEndOnly,
      options: [
        { id: 'ACTIVE', label: 'active' },
        { id: 'INACTIVE', label: 'inactive' },
      ],
    },
    description: {
      seq: 20,
      type: FieldType.Text,
      label: 'Description',
      listColumn: false,
    },
    source_type: {
      seq: 25,
      type: FieldType.Text,
      label: 'Source Type',
      persistence: PersistenceType.BackEndManaged,
    },
    source_id: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Source Id',
      persistence: PersistenceType.BackEndManaged,
    },
    parent_org_unit_id: {
      seq: 35,
      type: FieldType.Integer,
      label: 'Parent Org Unit',
      mandatory: true,
      listColumn: true,
    },
    level: {
      seq: 40,
      type: FieldType.Integer,
      label: 'Level',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
    },
    full_id: {
      seq: 45,
      type: FieldType.Text,
      label: 'Full Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
    },
    color_code: {
      seq: 50,
      type: FieldType.Colour,
      label: 'Colour Code',
    },
    institution_id: {
      seq: 55,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
    },
    created_at: {
      seq: 60,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
    },
    updated_at: {
      seq: 65,
      type: FieldType.Datetime,
      label: 'Updated At',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};

const parentOrgUnitField = OrgUnit.fields.parent_org_unit_id as ReferenceField;
parentOrgUnitField.type = FieldType.Reference;
parentOrgUnitField.refEntity = OrgUnit;
